export var PreapprovalPeriodType = /*#__PURE__*/ function(PreapprovalPeriodType) {
    PreapprovalPeriodType["None"] = "none";
    PreapprovalPeriodType["NoTimeLimit"] = "noTimeLimit";
    PreapprovalPeriodType["Weekly"] = "weekly";
    PreapprovalPeriodType["BiWeekly"] = "biweekly";
    PreapprovalPeriodType["Monthly"] = "monthly";
    PreapprovalPeriodType["Quarterly"] = "quarterly";
    PreapprovalPeriodType["Yearly"] = "yearly";
    return PreapprovalPeriodType;
}({});
export var RecurrencePeriodTypes = /*#__PURE__*/ function(RecurrencePeriodTypes) {
    RecurrencePeriodTypes["Weekly"] = "weekly";
    RecurrencePeriodTypes["BiWeekly"] = "biweekly";
    RecurrencePeriodTypes["Monthly"] = "monthly";
    RecurrencePeriodTypes["Quarterly"] = "quarterly";
    RecurrencePeriodTypes["Yearly"] = "yearly";
    return RecurrencePeriodTypes;
}({});
